import { create } from 'zustand';
import type { Country, Language } from '@gov-nx/api';
import { prop } from '@gov-nx/core/types';
import type { ListsState } from './store.types';

const initialState = {
	countries: [],
	languages: [],
};

const useListsStoreBase = create<ListsState>()((set) => ({
	...initialState,

	saveCountryList: (countries: Country[]) => set({ countries }),
	saveLanguageList: (languages: Language[]) => set({ languages }),
}));

export const useListsStore = <T extends keyof ListsState>(
	property: T
): ListsState[T] => useListsStoreBase(prop(property));

export const useListsStoreCountries = () => {
	const countries = useListsStore('countries');

	return {
		allCountries: countries,
		europeCountries: countries.filter(({ eu }) => eu),
	};
};
